module.exports = __webpack_public_path__ + "img/illustrator-something-wrong.0fd00e8d.svg";